const MOBILE_PHONE_NUMBER_MATCH_REGEX = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;

export { MOBILE_PHONE_NUMBER_MATCH_REGEX };
